
export const requiredString = (
    errorMessage?: string,
    value?: string | number
  ) => {
    const string = String(value).trim()
    if (!string || !value) return errorMessage ?? 'le champ est obligatoire'
    return
  }
  